import { AuditLogTable } from 'src/components/molecules';
import { AuditEntryType, useGetRoutingAuditEntriesQuery } from 'src/graphql';
import { AuditActions } from 'src/types';
import { formatDateTime } from 'src/utils/commonFunctions';

interface Props {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}

type RoutingAuditEntry =
  | AuditActions.CREATE_ROUTING_RULE
  | AuditActions.UPDATE_ROUTING_RULE
  | AuditActions.DELETE_ROUTING_RULE
  | AuditActions.DISABLE_ROUTING_RULE
  | AuditActions.ENABLE_ROUTING_RULE
  | AuditActions.UPDATE_ROUTING_RULE_PRIORITIES;

export const RoutingAuditLogTable = ({ isOpen, setIsOpen }: Props) => {
  const { data: routingAuditEntries } = useGetRoutingAuditEntriesQuery();

  const columns = [
    { label: 'User' },
    { label: 'Rule name' },
    { label: 'Event' },
    { label: 'Timestamp' },
  ];

  const tableDataCallback = (entry: AuditEntryType) => {
    const action = entry?.action as RoutingAuditEntry;
    const lowerEvent = action.replace('_ROUTING_RULE', '').toLowerCase() ?? '';
    const capEvent = lowerEvent?.charAt(0).toUpperCase() + lowerEvent?.slice(1);
    const event =
      capEvent === 'Update_priorities' ? 'Priorities Updated' : capEvent + 'd';
    return {
      cellData: [
        entry.User?.name || 'System',
        entry.data?.name ?? 'Untitled',
        event,
        formatDateTime(new Date(entry.createdAt)),
      ],
      row: `${entry.id}`, // A unique identifier for each row
    };
  };

  return (
    <AuditLogTable
      auditLogEntries={
        (routingAuditEntries?.routingAuditEntries as AuditEntryType[]) ?? []
      }
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      columns={columns}
      tableDataCallback={tableDataCallback}
      emptyText="No routing audit log entries."
    />
  );
};
